<template>
  <b-card
    title="مدیریت نوع کالاها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 ml-1"
                variant="primary"
                @click="addDivision()"
              >
                جدید
              </b-button>
              <b-button
                variant="success"
                class="mb-1 mr-auto ml-1"
                @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateDivision(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateDivision(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showDivisionModal"
      v-model="showDivisionModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات نوع کالا"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
    >

      <b-col md="12">
        <b-form-group
          label="عنوان"
          label-for="Title"
        >
          <b-form-input
            id="Title"
            v-model="row.Title"
            autocomplete="off"
          />
        </b-form-group>
      </b-col>

    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Division',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
      },
      showDivisionModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.division.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.division.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    save() {
      let url = this.$api.division.add
      if (this.row.Id) {
        url = this.$api.division.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showDivisionModal = true
        })
    },
    addDivision() {
      this.row = { Title: null }
      this.showDivisionModal = true
    },
    updateDivision(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.showDivisionModal = true
    },
    remove(id) {
      this.removeRow(this.$api.division.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>
